import * as React from "react"

type Success<T> = { success: true } & T
type Failure = { success: false; error: string }

export type DownloadFn = (playlistId: string) => Promise<Success<{ downloadUrl: string }> | Failure>

export type RequestDownloadFn = (playlistId: string, email: string) => Promise<Success<{}> | Failure>

export type DownloadContextValue = {
  download: DownloadFn
  requestDownload: RequestDownloadFn
  user?: { email?: string }
}

export const DownloadContext = React.createContext<DownloadContextValue | undefined>(undefined)
